<div class="dialog-container">
  <mat-dialog-content fxLayout="column" fxLayoutAlign="center center" class="activity-preview-dialog" [ngClass]="asset.assetTypeId.toLowerCase()">
    <div class="preview-content">
      @if (asset.assetTypeId === assetTypeIds.PERFORM) {
        <div class="preview-content-liner">
          <avenue-viewer [performTask]="asset" [currentCourse]="currentSelectedCourse"></avenue-viewer>
        </div>
      }

      @if (asset.assetTypeId  === assetTypeIds.CUSTOM_ACT) {
        <div class="preview-content-liner">
          <stimulus-activity
            [stimulus]="asset"
            [moduleID]="compositeID"
          ></stimulus-activity>
        </div>
      }

      @if (
        asset.assetTypeId === assetTypeIds.EBOOK_ACT ||
        asset.assetTypeId === assetTypeIds.EREADER
        ) {
        <div class="preview-content-liner"
          >
          <iframe
            [src]="embedUrl"
            frameborder="0"
            allowfullscreen
            allow="microphone *; camera *;"
            title="Resource Activity iframe"
          ></iframe>
        </div>
      }

      <!-- DevSpace -->
      @if (asset.assetActivityTypeId === assetActivityTypeIds.DEVSPACE) {
        <div class="preview-content-liner">
          <devspace-iframe [fidoUser]="fidoUserData"></devspace-iframe>
        </div>
      }

      <!-- MakeQuest -->
      @if (asset.assetActivityTypeId === assetActivityTypeIds.MAKEQUEST) {
        <div class="preview-content-liner">
          <iframe
            src="https://makequest.carnegielearning.com"
            frameborder="0"
            allowfullscreen
            allow="microphone *; camera *;"
            title="Make Quest iframe"
          ></iframe>
        </div>
      }

      <!-- Math -->
      @if (asset.assetTypeId === assetTypeIds.COG_TUTOR) {
        <div class="preview-content-liner">
          <lti-iframe
            [readOnly]="true"
            [launchType]="'math'"
            [asset]="asset"
            [user]="teacher"
            [course]="currentSelectedCourse"
            (submitEvent)="onSubmitMathWorkspace($event)"
          ></lti-iframe>
        </div>
      }

      @if (asset.assetTypeId === assetTypeIds.EXT_LINK) {
        <div class="preview-content-liner">
          <math-ext-link-activity [asset]="asset"></math-ext-link-activity>
        </div>
      }

      <!-- ReadyCheck -->
      @if (asset.assetTypeId === assetTypeIds.READYCHECK) {
        <div class="preview-content-liner">
          <lti-iframe
            [user]="teacher"
            [asset]="asset"
            [launchType]="'edulastic-ready-check'"
            [destination]="readyCheckDestination"
            [course]="(currentSelectedCourse)?currentSelectedCourse:currentMathCourse"
            [readOnly]="true"
          ></lti-iframe>
        </div>
      }

      @if (asset.assetTypeId === assetTypeIds.C2C) {
        <div class="preview-content-liner">
          <lti-iframe
            [user]="teacher"
            [asset]="asset"
            [launchType]="'c2c'"
            [destination]="readyCheckDestination"
            [course]="(currentSelectedCourse)?currentSelectedCourse:currentMathCourse"
            [readOnly]="true"
          ></lti-iframe>
        </div>
      }

      <div class="preview-action">
        <button mat-raised-button color="primary" (click)="onCancel()">Close</button>
      </div>
    </div>

  </mat-dialog-content>
</div>
